// English translations
export const en = {
  common: {
    save: 'Save',
    cancel: 'Cancel',
    delete: 'Delete',
    edit: 'Edit',
    create: 'Create',
    search: 'Search',
    loading: 'Loading...',
    noResults: 'No results',
    confirm: 'Confirm',
    yes: 'Yes',
    no: 'No',
    back: 'Back',
    next: 'Next',
    close: 'Close',
    export: 'Export',
    import: 'Import'
  },
  auth: {
    login: 'Login',
    logout: 'Logout',
    register: 'Register',
    email: 'Email',
    password: 'Password',
    forgotPassword: 'Forgot password?',
    resetPassword: 'Reset password',
    noAccount: "Don't have an account?",
    hasAccount: 'Already have an account?'
  },
  navigation: {
    dashboard: 'Dashboard',
    consents: 'Consents',
    titulars: 'Data Subjects',
    groups: 'Groups & Campaigns',
    analytics: 'Analytics',
    expiringAlerts: 'Expiring Alerts',
    rtbf: 'Right to be Forgotten',
    qrCode: 'QR Code',
    otpValidation: 'OTP Validation',
    exportData: 'Export Data',
    marketingActions: 'Marketing Actions',
    importExport: 'Import/Export',
    users: 'Users',
    dataBreaches: 'Data Breaches',
    backups: 'Backups',
    auditLogs: 'Audit Logs',
    settings: 'Settings'
  },
  consents: {
    title: 'Consent Management',
    newConsent: 'New Consent',
    activeConsents: 'Active Consents',
    revokedConsents: 'Revoked Consents',
    pendingConsents: 'Pending Consents',
    purposes: {
      newsletter: 'Newsletter',
      promotions: 'Promotions',
      events: 'Events',
      surveys: 'Surveys',
      productUpdates: 'Product Updates'
    },
    status: {
      active: 'Active',
      revoked: 'Revoked',
      pending: 'Pending',
      expired: 'Expired'
    },
    evidence: 'Evidence',
    expirationDate: 'Expiration Date',
    retentionPeriod: 'Retention Period'
  },
  titulars: {
    title: 'Data Subjects Management',
    newTitular: 'New Data Subject',
    editTitular: 'Edit Data Subject',
    groups: 'Groups',
    noGroups: 'No groups'
  },
  groups: {
    title: 'Data Subject Groups',
    newGroup: 'New Group',
    editGroup: 'Edit Group',
    members: 'Members',
    addMembers: 'Add Members'
  },
  campaigns: {
    title: 'Marketing Campaigns',
    newCampaign: 'New Campaign',
    purpose: 'Purpose',
    legalBasis: 'Legal Basis',
    targetGroups: 'Target Groups',
    status: {
      draft: 'Draft',
      pendingApproval: 'Pending Approval',
      approved: 'Approved',
      executed: 'Executed',
      cancelled: 'Cancelled'
    },
    approve: 'Approve',
    execute: 'Execute'
  },
  ropa: {
    title: 'Record of Processing Activities',
    exportPdf: 'Export PDF',
    exportExcel: 'Export Excel'
  },
  notifications: {
    title: 'Notifications',
    noNotifications: 'No notifications',
    markAllRead: 'Mark all',
    viewAll: 'View all'
  },
  settings: {
    title: 'Settings',
    language: 'Language',
    theme: 'Theme',
    lightTheme: 'Light',
    darkTheme: 'Dark',
    autoTheme: 'Auto'
  }
};
